import SkeletonAvatar from 'antd/es/skeleton/Avatar'
import {Avatar} from 'primereact/avatar'
import {OverlayPanel} from 'primereact/overlaypanel'
import {Tag} from 'primereact/tag'
import {useRef} from 'react'
import {isArrayAndNotEmpty} from '../../observations/Utils'
import {convertKeyToLabel} from '../../table-utils/TableUtils'
import {
    AccommodationStatusEnumList,
    DiagnosticEnumList,
    GenderEnumList,
    IdentityWithHeldReasonEnumList,
    MaritalStatusEnumList,
    ReligionEnumList,
    TitleEnumList,
} from './Constants'

function removeEscapes(jsonString) {
    let result = jsonString.replace(/\\"/g, '"')

    return result
}

const PathwaysComponent = ({pathways = []}) => {
    const overlayRef = useRef(null)

    if (!isArrayAndNotEmpty(pathways)) {
        return '-'
    }

    return (
        <div>
            {pathways?.length > 1 ? (
                <div
                    onMouseEnter={e => overlayRef.current.toggle(e)}
                    onMouseLeave={e => overlayRef.current.hide(e)}
                    style={{cursor: 'pointer'}}>
                    <div className="flex align-items-center">
                        <div className="mr-2">
                            <h6 className="font-bold mb-1 text-darkcyan">
                                {pathways.length} <span>Pathways</span>{' '}
                            </h6>
                        </div>
                        <div>
                            <i className="pi pi-info-circle"></i>
                        </div>
                    </div>

                    <OverlayPanel className="p-0 m-0" ref={overlayRef}>
                        <ul className="pl-2">
                            <h6 className="font-bold">Pathways</h6>
                            {pathways.map(pathway => (
                                <li
                                    key={pathway.id}
                                    className="mb-2"
                                    style={{listStyle: 'none'}}>
                                    <div className="flex align-items-center">
                                        <div className="mr-2">
                                            <img
                                                className="border-round-sm"
                                                src={pathway.icon}
                                                alt={pathway.name}
                                                width="22"
                                                height="22"
                                            />
                                        </div>
                                        <div className="font-lg">
                                            {pathway.name}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </OverlayPanel>
                </div>
            ) : (
                pathways?.map(pathway => (
                    <div key={pathway.id}>
                        <div className="flex align-items-center">
                            <div className="mr-2">
                                <img
                                    className="border-round-sm"
                                    src={pathway.icon}
                                    alt={pathway.name}
                                    width="22"
                                    height="22"
                                />
                            </div>
                            <div className="font-lg">{pathway.name}</div>
                        </div>
                    </div>
                ))
            )}
        </div>
    )
}

const HCPComponent = ({healthCarePractitioners = []}) => {
    const overlayRef = useRef(null)

    if (!isArrayAndNotEmpty(healthCarePractitioners)) {
        return '-'
    }

    return (
        <div>
            {healthCarePractitioners?.length > 1 ? (
                <div
                    onMouseEnter={e => overlayRef.current.toggle(e)}
                    onMouseLeave={e => overlayRef.current.hide(e)}
                    style={{cursor: 'pointer'}}>
                    <div className="flex align-items-center">
                        <div className="mr-2">
                            <h6 className="font-bold mb-1 text-darkcyan">
                                {healthCarePractitioners.length}{' '}
                                <span>Health Care Practitioners</span>{' '}
                            </h6>
                        </div>
                        <div>
                            <i className="pi pi-info-circle"></i>
                        </div>
                    </div>

                    <OverlayPanel className="p-0 m-0" ref={overlayRef}>
                        <ul className="pl-2">
                            <h6 className="font-bold">
                                Health Care Practitioners
                            </h6>
                            {healthCarePractitioners?.map(item => (
                                <li
                                    key={item.id}
                                    className="mb-2"
                                    style={{listStyle: 'none'}}>
                                    <div className="flex align-items-center">
                                        <div className="mr-2">
                                            {item.avatar ? (
                                                <img
                                                    className="border-round-lg"
                                                    src={item.avatar}
                                                    alt={item.firstName}
                                                    width="22px"
                                                    height="22px"
                                                />
                                            ) : (
                                                <Avatar
                                                    icon="pi pi-user"
                                                    size="medium"
                                                    shape="circle"
                                                    className="p-mr-2 border-round-lg"
                                                    style={{
                                                        width: '22px',
                                                        height: '22px',
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <div className="font-lg">
                                            {item.firstName} {item.lastName}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </OverlayPanel>
                </div>
            ) : (
                healthCarePractitioners?.map(item => (
                    <div key={item.id}>
                        <div className="flex align-items-center">
                            <div className="mr-2">
                                {item.avatar ? (
                                    <img
                                        className="border-round-md"
                                        src={item.avatar}
                                        alt={item.firstName}
                                        width="22px"
                                        height="22px"
                                    />
                                ) : (
                                    <SkeletonAvatar
                                        size="medium"
                                        shape="circle"
                                        className="p-mr-2 border-round-md"
                                        icon="pi pi-user"
                                        style={{
                                            width: '22px',
                                            height: '22px',
                                        }}
                                    />
                                )}
                            </div>
                            <div className="font-lg">
                                {item.firstName} {item.lastName}
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    )
}

const StaticListComponent = ({staticLists = []}) => {
    const overlayRef = useRef(null)

    if (!isArrayAndNotEmpty(staticLists)) {
        return '-'
    }

    return (
        <div>
            {staticLists?.length > 1 ? (
                <div
                    onMouseEnter={e => overlayRef.current.toggle(e)}
                    onMouseLeave={e => overlayRef.current.hide(e)}
                    style={{cursor: 'pointer'}}>
                    <div className="flex align-items-center">
                        <div className="mr-2">
                            <h6 className="font-bold mb-1 text-darkcyan">
                                {staticLists.length} <span>Static Lists</span>{' '}
                            </h6>
                        </div>
                        <div>
                            <i className="pi pi-info-circle"></i>
                        </div>
                    </div>

                    <OverlayPanel className="p-0 m-0" ref={overlayRef}>
                        <ul className="pl-2">
                            <h6 className="font-bold">Static Lists</h6>
                            {staticLists?.map(item => (
                                <li
                                    key={item.id}
                                    className="mb-2"
                                    style={{listStyle: 'none'}}>
                                    <div className="flex align-items-center">
                                        <div>
                                            <i className="pi pi-list mr-2"></i>
                                        </div>
                                        <div className="font-lg">
                                            {item?.name}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </OverlayPanel>
                </div>
            ) : (
                staticLists?.map(item => (
                    <div key={item.id}>
                        <div className="flex align-items-center">
                            <div>
                                <i className="pi pi-list mr-2"></i>
                            </div>
                            <div className="font-lg">{item?.name}</div>
                        </div>
                    </div>
                ))
            )}
        </div>
    )
}

//#region Patient Table
export const columnList = [
    {
        field: 'title',
        header: 'Title',
        initialShown: true,
    },
    {field: 'firstName', header: 'First Name', initialShown: true},
    {
        field: 'lastName',
        header: 'Last Name',
        initialShown: true,
    },
    {
        field: 'age',
        header: 'Age',
        initialShown: true,
        body: rowData =>
            rowData?.age ? (
                <span>
                    {rowData.age && (
                        <span className="font-bold"> {rowData.age} </span>
                    )}
                    {`${rowData?.dob ? ` (${rowData.dob})` : ''}`}{' '}
                </span>
            ) : (
                'N/A'
            ),
    },
    {
        field: 'nhsNumber',
        header: 'NHS Number',
        initialShown: true,
        body: rowData =>
            rowData?.nhsNumber ? <span>{rowData.nhsNumber}</span> : '-',
    },
    {
        field: 'hospitalName',
        header: 'Hospital Name',
        initialShown: true,
        body: rowData =>
            rowData?.hospitalName ? <span>{rowData.hospitalName}</span> : '-',
    },

    {
        field: 'healthCarePractitioners',
        header: 'HC.Practitioner',
        initialShown: true,
        body: rowData => {
            if (!rowData['healthCarePractitioners']) {
                return '-'
            }

            let healthCarePractitioners = []
            try {
                healthCarePractitioners = JSON.parse(
                    rowData['healthCarePractitioners'],
                )
            } catch (e) {
                console.log(e)
            }

            return (
                <HCPComponent
                    healthCarePractitioners={healthCarePractitioners}
                />
            )
        },
    },
    {
        field: 'pathways',
        header: 'Pathways',
        initialShown: true,
        body: rowData => {
            if (!rowData['pathways']) {
                return '-'
            }

            let pathways = []
            try {
                pathways = JSON.parse(rowData['pathways'])
            } catch (e) {
                console.log(e)
            }

            return <PathwaysComponent pathways={pathways} />
        },
    },
    {
        field: 'staticLists',
        header: 'Static Lists',
        initialShown: true,
        body: rowData => {
            if (!rowData['staticLists']) {
                return '-'
            }

            let staticLists = []
            try {
                staticLists = JSON.parse(rowData['staticLists'])
            } catch (e) {
                console.log(e)
            }

            return <StaticListComponent staticLists={staticLists} />
        },
    },
    {
        field: 'currentLocation',
        header: 'Current Location',
        initialShown: false,
        body: rowData => {
            if (!rowData['currentLocation']) {
                return '-'
            }
            return rowData['currentLocation']
        },
    },
    {
        field: 'lastLocation',
        header: 'Last Location',
        initialShown: false,
        body: rowData => {
            if (!rowData['lastLocation']) {
                return '-'
            }
            return rowData['lastLocation']
        },
    },
    {
        field: 'sicknessLevel',
        header: 'Sickness Level',
        initialShown: true,
        body: rowData =>
            rowData['sicknessLevel'] !== null ? (
                <Tag
                    className="px-3"
                    severity={
                        rowData['sicknessStatus'] === 'normal'
                            ? 'success'
                            : rowData['sicknessStatus'] === 'mild'
                            ? 'info'
                            : rowData['sicknessStatus'] === 'moderate'
                            ? 'warning'
                            : rowData['sicknessStatus'] === 'severe'
                            ? 'danger'
                            : ''
                    }
                    value={
                        rowData['sicknessStatus'] === 'normal'
                            ? 'NORMAL'
                            : rowData['sicknessStatus'] === 'mild'
                            ? 'MILD'
                            : rowData['sicknessStatus'] === 'moderate'
                            ? 'MODERATE'
                            : rowData['sicknessStatus'] === 'severe'
                            ? 'SEVERE'
                            : ''
                    }
                />
            ) : (
                'N/A'
            ),
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
    },
    {
        field: 'news',
        header: 'NEWS',
        initialShown: false,
        body: rowData =>
            rowData?.news ? (
                <span className="font-bold text-darkcyan">{rowData?.news}</span>
            ) : (
                '-'
            ),
    },
    {
        field: 'email',
        header: 'Email',
        initialShown: false,
    },
    {
        field: 'fullName',
        header: 'Full Name',
        initialShown: false,
    },
    {
        field: 'gender',
        header: 'Gender',
        initialShown: false,
    },
    {
        field: 'hospitalNumber',
        header: 'Hospital Number',
        initialShown: false,
    },
    {
        field: 'addressType',
        header: 'Address Type',
        initialShown: false,
        body: rowData => {
            if (!rowData['addressType']) {
                return 'N/A'
            }
            return rowData['addressType']
                ? convertKeyToLabel(rowData['addressType'])
                : 'N/A'
        },
    },
    {
        field: 'address',
        header: 'Address',
        initialShown: false,
        body: rowData => {
            if (!rowData['address']) {
                return '-'
            }
            return <span>{rowData['address']}</span>
        },
    },
    {
        field: 'postalCode',
        header: 'Postal Code',
        initialShown: false,
        body: rowData => {
            if (!rowData['postalCode']) {
                return '-'
            }
            return <span className="uppercase">{rowData['postalCode']}</span>
        },
    },
    {
        field: 'phone',
        header: 'Phone',
        initialShown: false,
        body: rowData => {
            if (
                !rowData['phone'] ||
                rowData['phone'] === '' ||
                rowData['phone']?.length < 4
            ) {
                return 'N/A'
            }
            return rowData['phone']
        },
    },
    {
        field: 'identityWithHeldReason',
        header: 'Identity Withheld Reason',
        initialShown: false,
        body: rowData => {
            if (!rowData['identityWithHeldReason']) {
                return '-'
            }
            return rowData['identityWithHeldReason']
                ? convertKeyToLabel(rowData['identityWithHeldReason'])
                : '-'
        },
    },
    {
        field: 'maritalStatus',
        header: 'Marital Status',
        initialShown: false,
        body: rowData => {
            if (!rowData['maritalStatus']) {
                return '-'
            }
            return rowData['maritalStatus']
                ? convertKeyToLabel(rowData['maritalStatus'])
                : '-'
        },
    },
    {
        field: 'religion',
        header: 'Religion',
        initialShown: false,
        body: rowData => {
            if (!rowData['religion']) {
                return '-'
            }
            return rowData['religion']
                ? convertKeyToLabel(rowData['religion'])
                : '-'
        },
    },
    {
        field: 'accommodationStatus',
        header: 'Accommodation Status',
        initialShown: false,
        body: rowData => {
            if (!rowData['accommodationStatus']) {
                return '-'
            }
            return rowData['accommodationStatus']
                ? convertKeyToLabel(rowData['accommodationStatus'])
                : '-'
        },
    },
    {
        field: 'diagnostic',
        header: 'Diagnostic',
        initialShown: false,
        body: rowData => {
            if (!rowData['diagnostic']) {
                return '-'
            }
            return rowData['diagnostic']
                ? convertKeyToLabel(rowData['diagnostic'])
                : '-'
        },
    },
    {
        field: 'hasDeviceAssigned',
        header: 'Device Assigned ?',
        initialShown: false,
        body: rowData => {
            return (
                <Tag
                    className="px-3"
                    severity={
                        rowData['hasDeviceAssigned'] ? 'success' : 'danger'
                    }
                    value={rowData['hasDeviceAssigned'] ? 'Yes' : 'No'}
                />
            )
        },
    },
    {
        field: 'deviceName',
        header: 'Device Name',
        initialShown: false,
        body: rowData => {
            if (!rowData['deviceName']) {
                return '-'
            }
            return rowData['deviceName']
        },
    },
    {
        field: 'deviceBrand',
        header: 'Device Brand',
        initialShown: false,
        body: rowData => {
            if (!rowData['deviceBrand']) {
                return '-'
            }
            return rowData['deviceBrand']
        },
    },
    {
        field: 'importedAt',
        header: 'Data Source',
        initialShown: false,
        body: rowData => {
            if (rowData['importedAt']) {
                return <span>Imported from the other system</span>
            }

            return 'Created in the system'
        },
    },
]
//#endregion

//#region Column Header Reference
const patientKeys = {
    username: 'username',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    nhsNumber: 'nhsNumber',
    dob: 'dob',
    title: 'title',
    gender: 'gender',
    currentLocation: 'currentLocation',
    occupation: 'occupation',
    maritalStatus: 'maritalStatus',
    religion: 'religion',
    accommodationStatus: 'accommodationStatus',
    identityWithHeldReason: 'identityWithHeldReason',
    diagnostic: 'diagnostic',
    country: 'country',
    state: 'state',
    city: 'city',
    addressLine1: 'addressLine1',
    addressLine2: 'addressLine2',
    addressLine3: 'addressLine3',
    addressLine4: 'addressLine4',
    postalCode: 'postalCode',
    phone: 'phone',
}

export const valueType = {
    text: 'Text',
    email: 'Email',
    number: 'Numerical',
    yes_no: 'yes/no',
    date: 'Date',
    enum: 'Enum',
    float: 'Float (Decimal number)',
    url: 'URL',
}

export const importErrorType = {
    notAcceptedColumn: 'notAcceptedColumn',
    notAcceptedValues: 'notAcceptedValues',
    missingMinimalColumns: 'missingMinimalColumns',
}

export const dateFormatForImport = 'dd-mm-yyyy'

export const patientColumnHeaderReferenceList = [
    {
        column: patientKeys.username,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'jdoe123',
    },
    {
        column: patientKeys.firstName,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'John',
    },
    {
        column: patientKeys.lastName,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'Doe',
    },
    {
        column: patientKeys.email,
        valueType: valueType.email,
        description: '',
        acceptedValues: valueType.email,
        example: 'jdoe123@example.com',
    },
    {
        column: patientKeys.nhsNumber,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: '1234567890',
    },
    {
        column: patientKeys.dob,
        valueType: valueType.date,
        description: '',
        acceptedValues: dateFormatForImport,
        example: '12/03/1985',
    },
    {
        column: patientKeys.title,
        valueType: valueType.enum,
        description: '',
        acceptedValues: TitleEnumList,
        example: 'mr',
    },
    {
        column: patientKeys.gender,
        valueType: valueType.enum,
        description: '',
        acceptedValues: GenderEnumList,
        example: 'male',
    },
    {
        column: patientKeys.currentLocation,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'London',
    },
    {
        column: patientKeys.occupation,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'Software Engineer',
    },
    {
        column: patientKeys.maritalStatus,
        valueType: valueType.enum,
        description: '',
        acceptedValues: MaritalStatusEnumList,
        example: 'mMarriedCivilPartner',
    },
    {
        column: patientKeys.religion,
        valueType: valueType.enum,
        description: '',
        acceptedValues: ReligionEnumList,
        example: 'chChristianScientist',
    },
    {
        column: patientKeys.accommodationStatus,
        valueType: valueType.enum,
        description: '',
        acceptedValues: AccommodationStatusEnumList,
        example: 'patientHasOwnStableAccommodationEgHomeflat',
    },
    {
        column: patientKeys.identityWithHeldReason,
        valueType: valueType.enum,
        description: '',
        acceptedValues: IdentityWithHeldReasonEnumList,
        example: 'unknown',
    },
    {
        column: patientKeys.diagnostic,
        valueType: valueType.enum,
        description: '',
        acceptedValues: DiagnosticEnumList,
        example: 'skin',
    },
    {
        column: patientKeys.country,
        valueType: valueType.text,
        description: '',
        acceptedValues: (
            <div>
                <a
                    className="underline font-semibold"
                    target="_blank"
                    href="https://www.iso.org/obp/ui/#search"
                    rel="noreferrer">
                    Country Alpha-2 Code
                </a>
            </div>
        ),
        example: 'GB',
    },
    {
        column: patientKeys.state,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'England',
    },
    {
        column: patientKeys.city,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'London',
    },
    {
        column: patientKeys.addressLine1,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: '123 Oxford St',
    },
    {
        column: patientKeys.addressLine2,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'Apartment 5',
    },
    {
        column: patientKeys.addressLine3,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'Room 12',
    },
    {
        column: patientKeys.addressLine4,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'N/A',
    },
    {
        column: patientKeys.postalCode,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: 'W1D 1BS',
    },
    {
        column: patientKeys.phone,
        valueType: valueType.text,
        description: '',
        acceptedValues: valueType.text,
        example: '+44 7700 900123',
    },
]

//#endregion
